import React, { useEffect, useRef } from "react";
import { TextField } from "@mui/material";
import { LoadScript } from "@react-google-maps/api";

const libraries = ["places"];

const CityAutocompleteInput = ({ city, onSelect }) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (!window.google || !inputRef.current) return;

    // Initialize autocomplete
    autocompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["(cities)"],
        componentRestrictions: { country: "us" },
        fields: [
          "address_components",
          "formatted_address",
          "geometry",
          "name",
        ],
      }
    );

    // Listen for selection
    const listener = autocompleteRef.current.addListener(
      "place_changed",
      () => {
        const place = autocompleteRef.current.getPlace();

let cityName = "";
let stateName = "";
let stateCode = "";
        let latitude = null;
        let longitude = null;

        // ✅ Extract city & state
        if (place.address_components) {
        place.address_components.forEach((component) => {
  if (component.types.includes("locality")) {
    cityName = component.long_name;
  }

  if (component.types.includes("administrative_area_level_1")) {
    stateName = component.long_name;   // ✅ correct
    stateCode = component.short_name;  // ✅ correct
  }
});
        }

        // Fallback (sometimes locality missing)
        if (!cityName && place.name) {
          cityName = place.name;
        }

        // ✅ Extract lat/lng
        if (place.geometry && place.geometry.location) {
          latitude = place.geometry.location.lat();
          longitude = place.geometry.location.lng();
        }

onSelect({
  city: cityName,
  stateName, 
  stateCode,
  latitude,
  longitude,
  fullAddress: place.formatted_address || "",
});
      }
    );

    return () => {
      if (listener) listener.remove();
    };
  }, [onSelect]);

  // Sync external value → input
  useEffect(() => {
    if (inputRef.current && city) {
      inputRef.current.value = city;
    }
  }, [city]);

  return (
    <TextField
      label="City"
      fullWidth
      inputRef={inputRef}
      placeholder="Start typing city..."
      InputLabelProps={{ shrink: true }}
    />
  );
};

export default function CityAutocomplete(props) {
  return (
    <LoadScript
      googleMapsApiKey="AIzaSyCpQ78QeqL01B3fyNWUrdib6ZRL46E9CCw" // ✅ use env
      libraries={libraries}
    >
      <CityAutocompleteInput {...props} />
    </LoadScript>
  );
}